import { render, staticRenderFns } from "./SavingItem.vue?vue&type=template&id=f6cc9e42&scoped=true"
import script from "./SavingItem.vue?vue&type=script&lang=js"
export * from "./SavingItem.vue?vue&type=script&lang=js"
import style0 from "./SavingItem.vue?vue&type=style&index=0&id=f6cc9e42&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6cc9e42",
  null
  
)

export default component.exports